/** @file Panel: a titled editor panel (tree, inspector, timeline) with optional header actions. */
import type { ReactElement, ReactNode } from 'react';

/** The header title, header-right actions, the scrolling body and an optional `data-panel` id. */
export type PanelProps = { title: string; actions?: ReactNode; children: ReactNode; panelId?: string };

/** A full-height column: header strip, then a body that scrolls on its own. */
export function Panel({ title, actions, children, panelId }: PanelProps): ReactElement {
  return (
    <section className="p3-panel" aria-label={title} data-panel={panelId}>
      <header className="p3-panel-head"><span>{title}</span><span className="p3-spacer" />{actions}</header>
      <div className="p3-panel-body">{children}</div>
    </section>
  );
}
